/* projects/speaker-platform/src/app/organisms/speakers-list/speakers-list.component.scss */
/*# sourceMappingURL=speakers-list.component-ITGEYJ2J.css.map */
